/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { litellmListInstances } from "../funcs/litellmListInstances.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListInstancesResponseBody } from "../models/components/listinstancesresponsebody.js";
import {
  ListLiteLLMInstancesRequest,
  ListLiteLLMInstancesSecurity,
} from "../models/operations/listlitellminstances.js";
import { unwrapAsync } from "../types/fp.js";
export type LiteLLMInstancesQueryData = ListInstancesResponseBody;

export function prefetchLiteLLMInstances(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListLiteLLMInstancesRequest | undefined,
  security?: ListLiteLLMInstancesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildLiteLLMInstancesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildLiteLLMInstancesQuery(
  client$: GramCore,
  request?: ListLiteLLMInstancesRequest | undefined,
  security?: ListLiteLLMInstancesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<LiteLLMInstancesQueryData>;
} {
  return {
    queryKey: queryKeyLiteLLMInstances({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function liteLLMInstancesQueryFn(
      ctx,
    ): Promise<LiteLLMInstancesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(litellmListInstances(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyLiteLLMInstances(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "litellm", "listInstances", parameters];
}
